<ng-container *transloco="let t">
  <app-page-template>
    <div class="container container-no-padding-sm">
      <app-page-header-public [currentItem]="league" [showLogo]="false" [showDateBadge]="false"
                              [showLinearGradient]="false"/>
      <app-info-section-public [currentItem]="league" [languages]="languages" [showTrailingLocation]="false"
                               [showBreadcrumbs]="true" [currentItemType]="CurrentItemType.LEAGUE">
        <ng-container slot="title-slot">
          <h1 class="info-area__title flex-grow-1 trim-text-second-line pe-2">
            <app-language-output [hrLabel]="league?.name" [enLabel]="league?.nameEng" [bsLabel]="league?.nameBs"
                                 [itLabel]="league?.nameIta" [siLabel]="league?.nameSlo" [srLabel]="league?.nameSr"
                                 [defaultLanguage]="league?.defaultLanguage" [languages]="languages"/>
          </h1>
        </ng-container>
      </app-info-section-public>
    </div>
    <div class="container nav-bar-padding">
      <app-nav-tabs>
        <app-nav-tab [title]="t('app.common.events')" [itemId]="1">
          <ng-template>
            <div class="pt-62-32 pb-300-100">
              <app-league-event-list-tab [league]="league" [languages]="languages"
                                         [countries]="countries"/>
            </div>
          </ng-template>
        </app-nav-tab>
        <app-nav-tab [title]="t('league.info')" [itemId]="2">
          <ng-template>
            <app-league-info-tab [currentEventItem]="league" [languages]="languages"/>
          </ng-template>
        </app-nav-tab>
        <app-nav-tab [title]="t('league.contact')" [itemId]="3">
          <ng-template>
            <app-contacts-tab [currentItem]="league" [languages]="languages"/>
          </ng-template>
        </app-nav-tab>
        <app-nav-tab [title]="t('league.results')" [itemId]="4">
          <ng-template>
            <app-league-results-tab/>
          </ng-template>
        </app-nav-tab>
        <div class="d-none d-xxl-flex">
          <app-share-cta [leagueItem]="league"/>
        </div>
      </app-nav-tabs>
    </div>
  </app-page-template>
</ng-container>
